import React from "react";

export default ({ data }) => {
	return (
		<>
			<h3>Friendraiser</h3>
			<p>
				Consider becoming a “Friendraiser” by{" "}
				<a
					href={`https://valerotexasopen.com/championsforecharity/friends/signup?code=${data.charityCode}`}
					target="_blank"
					rel="noopener noreferrer"
				>
					creating your own fundraising page
				</a>{" "}
				to further support our mission.
			</p>
		</>
	);
};
